import templateUrl from "emun.auth/register-confirmation.htm";
export default () => ({ templateUrl });
